import { CommonPrivacy } from 'features/common'
import { Group } from 'features/groups'
import { Dispatch, ReactElement, SetStateAction } from 'react'
import { FieldValues } from 'react-hook-form'

export const DEVELOPERS_PATH = '/developers'
export enum DevelopersSection {
  Overview = '',
  Credentials = 'credentials',
  NamedSources = 'named-sources',
  Workflows = 'workflows'
}

export enum CredentialType {
  AccessToken = 'token',
  SPA = 'spa',
  M2M = 'm2m'
}

export interface Documentation {
  icon: ReactElement
  category: string
  title: string
  href: string
}

export interface Update {
  type: string
  date: Date | string
  title: string
  description: string
}

export interface TokensResponse {
  token: string
}

export type OAuthClientType = CredentialType.SPA | CredentialType.M2M

export interface OAuthClient extends FieldValues {
  id: string
  client_id: string
  title: string
  privacy: CommonPrivacy
  app_type: OAuthClientType
  createdAt: Date
  updatedAt: Date
  groups?: Group[]
}

export interface SpaOauthClient extends FieldValues {
  title: string
  initiate_login_uri: string
  callbacks: string | string[]
  allowed_logout_urls: string | string[]
  allowed_origins: string | string[]
  web_origins: string | string[]
  client_id: string
  client_secret: string
}

export interface M2MOauthClient extends FieldValues {
  title: string
  client_id: string
  client_secret: string
}

export type DevelopersOutletContext = {
  useWithPageWrapper: [boolean, Dispatch<SetStateAction<boolean>>]
  useShowingCredential: [CredentialType, Dispatch<SetStateAction<CredentialType>>]
}
